// extracted by mini-css-extract-plugin
export default {"modal":"ButtonModal_modal__StdDz","extraInfo":"ButtonModal_extraInfo__6V47A","logo":"ButtonModal_logo__g6Cum"};